/**
 * Centralized logger.
 *
 * - In development (`NODE_ENV !== "production"`): logs to the console.
 * - In production: console noise is suppressed; `error()` is forwarded to Sentry
 *   (lazy-imported, mirroring the init in `index.js`) so real failures are captured.
 *
 * Use this instead of `console.*` everywhere (enforced by the `no-console` ESLint rule).
 */
const isDev = process.env.NODE_ENV !== "production";

const forwardToSentry = (args) => {
  import("@sentry/react")
    .then((Sentry) => {
      const err = args.find((a) => a instanceof Error);
      if (err) {
        Sentry.captureException(err);
      } else {
        Sentry.captureMessage(args.map((a) => String(a)).join(" "), "error");
      }
    })
    .catch(() => {
      /* Sentry unavailable (e.g. no DSN) — drop silently */
    });
};

export const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },
  info: (...args) => {
    if (isDev) console.info(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  error: (...args) => {
    if (isDev) {
      console.error(...args);
    } else {
      forwardToSentry(args);
    }
  },
};

export default logger;
